<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="create-profile-dialog"
      :open.sync="openDialog"
      :form-ref.sync="profileFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Créer un profil</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <profile-form
            :profile-form="profileForm"
            :attributes-choice="attributesChoice"
            :rules="rules"
          ></profile-form>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Créer</template>
    </base-dialog>
  </div>
</template>
<script>
import { onMounted, computed, toRefs } from "@vue/composition-api";
import BaseDialog from "@/components/General/BaseDialog.vue";
import { useProfile } from "../../composables/profile";
import ProfileForm from "./ProfileForm";

export default {
  components: {
    ProfileForm,
    BaseDialog,
  },
  props: {
    profile: Object,
    partner: Object,

    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { createProfile, profileData, attributesChoice } = useProfile();

    /* Variables */

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Cycle de vie */
    onMounted(() => {
      profileData.profileForm.attributes.push({
        name: attributesChoice[0].value,
        value: "",
      });
    });

    /* Méthodes */
    const saveItem = async function () {
      await createProfile(props.partner.id);
      openDialog.value = profileData.createProfileDialog;
    };

    return {
      saveItem,
      openDialog,
      ...toRefs(profileData),
      attributesChoice,
    };
  },
};
</script>
